// extracted by mini-css-extract-plugin
module.exports = {"main-component":"eventBackground_main-component__WXAPD"};